"use strict";
var Observable_1 = require('../../Observable');
var debounceTime_1 = require('../../operator/debounceTime');
Observable_1.Observable.prototype.debounceTime = debounceTime_1.debounceTime;
//# sourceMappingURL=debounceTime.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/add/operator/debounceTime.js
 ** module id = 483
 ** module chunks = 2
 **/